module.exports = "/fast-coin/img/coin/anim/in/coin_in_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_021.png
// module id = 2291
// module chunks = 5